<template>
    <div class="reports">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">
                   <inertia-link :href="'/backoffice/reports'" class="name">
                    <v-icon color="#921E61" class="mb-1">mdi-arrow-left-circle</v-icon>
                    {{ $page.props.lang.back || "Reports" }}
                </inertia-link>
                / {{ $page.props.lang.subscriptions || "Memberships" }}</h2>
            </div>
        </div>
        <!-- <div class="table-header">
            <div class="pickers">
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.fromDate || 'From date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="fromDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="fromDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="fromDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="fromDate" :max="toDate"
                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.toDate || 'To date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="toDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="toDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="toDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="toDate" :min="fromDate"
                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <v-btn @click="filterByDates" color="primary" height="38">{{ $page.props.lang.apply || 'Apply' }}</v-btn>
            </div>
            <div class="totals">
                <h4 class="total">{{ $page.props.lang.totalSales || 'Total sales' }}: {{ total_sales }}</h4>
            </div>
        </div> -->
        <div class="export-btn">
            <v-tooltip bottom open-delay="400">
                <template v-slot:activator="{on, attrs}">
                    <v-btn @click="exportSubscriptions" color="primary" fab x-small outlined v-bind="attrs" v-on="on">
                        <v-icon>mdi-file-excel-box</v-icon>
                    </v-btn>
                </template>
                <span>{{ $page.props.lang.export || 'Export' }}</span>
            </v-tooltip>
        </div>
        <div class="table-container">
            <v-data-table
            :headers="subscriptionsHeaders"
            :items="subscriptions"
            :page.sync="tablePage"
            @page-count="tablePageCount = $event"
            item-key="item.id"
            mobile-breakpoint="0"
            hide-default-footer>
                <template v-slot:item.name="{ item }">
                    <div class="name-medium">
                        <inertia-link :href="'/backoffice/subscriptions/view/'+ item.id" class="name">
                            {{ item.name }}
                        </inertia-link>
                    </div>
                </template>
                <template v-slot:item.description="{ item }">
                    {{ item.description }}
                </template>
                <!-- <template v-slot:item.active_members="{ item }">
                    {{ item.active_members }}
                </template> -->
                <template v-slot:item.total_sales="{ item }">
                    {{ item.total_sales === null ? 0 : item.total_sales }}
                </template>
            </v-data-table>
        </div>
        <v-pagination v-model="tablePage" :length="tablePageCount" class="front-paginate"></v-pagination>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'


export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Memberships Report"
        }
    },
    layout: AppLayout,
    props: {
        subscriptions: Array,
        total_sales: Number,
        lang: Object
    },
    data(){
        return {
            totalPayments: this.total_payments,
            date: moment().format('YYYY-MM-DD'),
            fromDatePicker: false,
            fromDate: moment().add(-30, 'days').format('YYYY-MM-DD'),
            toDatePicker: false,
            toDate: moment().format('YYYY-MM-DD'),
            subscriptionsHeaders: [
                {text: this.lang.name || 'Name', value: 'name', align: 'start'},
                {text: this.lang.description || 'Description', value: 'description', sortable: false},
                // {text: this.lang.totalSales || 'Total Sales', value: 'total_sales', align: 'center', sortable: false},
                {text: this.lang.activeMembers || 'Active members', value: 'active_members', align: 'center', sortable: false},
            ],
            tablePageCount: 0,
            tablePage: 1
        }
    },
    methods: {
        filterByDates() {
            this.$inertia.replace('/backoffice/reports/subscriptions?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate)
        },
        exportSubscriptions(){
            window.location.href = '/backoffice/reports/subscriptions/export',
                    {only:['subscriptions']}
        }
    }
}

</script>